import React from 'react';
import * as metaPixel from 'meta-pixel';
import { Clock, Package } from 'lucide-react';
const handlePurchaseClick = () => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      metaPixel.track('InitiateCheckout', {
        content_name: 'Cría con calma - Hero CTA',
        content_category: 'Parenting Guide',
        value: 7.99,
        currency: 'USD'
      });
    }
  } catch (error) {
    console.error('Error tracking purchase click:', error);
  }
};
export function Hero() {
  return <section className="w-full bg-gradient-to-b from-amber-50 to-white py-8 md:py-16" data-id="element-248">
      <div className="container mx-auto px-4 md:px-6" data-id="element-249">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-8" data-id="element-250">
          <div className="md:w-1/2 space-y-4 md:space-y-5" data-id="element-251">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-amber-900 font-serif leading-tight flex items-center gap-2" data-id="element-252">
              <span className="text-amber-600" data-id="element-253">🧡</span> Deja de gritar: guía
              paso a paso para rutinas que tus hijos sí siguen
            </h1>
            <h2 className="text-xl md:text-2xl font-medium text-amber-800 font-serif" data-id="element-254">
              Rutinas visuales y límites amables para mañanas, noches y cenas…
              sin gritos, sin drama.
            </h2>
            <div className="relative py-2 md:hidden" data-id="element-255">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bDACsPzr4cRx9ZRDZYGz1A/Gemini_Generated_Image_6xgh96xgh96xgh96.png" alt="Familia disfrutando tiempo juntos en casa" className="rounded-lg shadow-xl w-full" data-id="element-256" />
              <div className="absolute top-0 right-0 bg-red-600 text-white py-1 px-3 rounded-bl-lg rounded-tr-lg font-bold text-sm" data-id="element-257">
                83% DESCUENTO
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 py-2" data-id="element-258">
              <div className="bg-amber-50 rounded-md p-2 text-center border border-amber-100" data-id="element-259">
                <p className="text-amber-800 font-medium text-sm" data-id="element-260">
                  <span className="text-amber-600" data-id="element-261">🟠</span> Más cooperación
                </p>
              </div>
              <div className="bg-amber-50 rounded-md p-2 text-center border border-amber-100" data-id="element-262">
                <p className="text-amber-800 font-medium text-sm" data-id="element-263">
                  <span className="text-amber-600" data-id="element-264">🟠</span> Menos caos
                </p>
              </div>
              <div className="bg-amber-50 rounded-md p-2 text-center border border-amber-100" data-id="element-265">
                <p className="text-amber-800 font-medium text-sm" data-id="element-266">
                  <span className="text-amber-600" data-id="element-267">🟠</span> Sin repetir
                </p>
              </div>
            </div>
            <div className="bg-amber-100 border border-amber-200 rounded-lg p-3 flex items-center gap-2" data-id="element-268">
              <Package size={20} className="text-amber-700 flex-shrink-0" data-id="element-269" />
              <p className="text-amber-900 font-medium text-sm" data-id="element-270">
                <span className="font-bold" data-id="element-271">📦 Incluye 3 ebooks</span> listos
                para descargar
              </p>
            </div>
            <div className="bg-red-50 border border-red-200 rounded-lg p-3 flex items-center gap-2" data-id="element-272">
              <Clock size={20} className="text-red-600 flex-shrink-0" data-id="element-273" />
              <p className="text-red-600 font-medium text-sm" data-id="element-274">
                <span className="font-bold" data-id="element-275">🎁 ¡Solo hoy por $7.99!</span>{' '}
                <span className="line-through" data-id="element-276">(antes $47.99)</span>
              </p>
            </div>
            <div className="pt-3" data-id="element-277">
              <a href="https://pay.hotmart.com/E103092077E" onClick={handlePurchaseClick} data-id="element-278">
                <button className="bg-amber-700 hover:bg-amber-800 text-white font-medium text-lg py-3 px-6 rounded-md w-full shadow-md" data-id="element-279">
                  Quiero la rutina sin gritos →
                </button>
              </a>
            </div>
          </div>
          <div className="md:w-1/2 mt-6 md:mt-0 hidden md:block" data-id="element-280">
            <div className="relative" data-id="element-281">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bDACsPzr4cRx9ZRDZYGz1A/Gemini_Generated_Image_6xgh96xgh96xgh96.png" alt="Familia disfrutando tiempo juntos en casa" className="rounded-lg shadow-xl w-full" data-id="element-282" />
              <div className="absolute top-0 right-0 bg-red-600 text-white py-1 px-3 rounded-bl-lg rounded-tr-lg font-bold text-sm" data-id="element-283">
                83% DESCUENTO
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6 md:mt-8 bg-amber-50 border border-amber-100 rounded-lg p-4" data-id="element-284">
          <h3 className="text-center text-amber-800 font-medium mb-3" data-id="element-285">
            Padres como tú ya lo están usando
          </h3>
          <div className="flex flex-wrap justify-center gap-3" data-id="element-286">
            <div className="flex items-center gap-2 bg-white px-3 py-2 rounded-full border border-amber-100" data-id="element-287">
              <img src="https://randomuser.me/api/portraits/women/42.jpg" alt="Ana, Ciudad de Guatemala" className="w-8 h-8 rounded-full object-cover" data-id="element-288" />
              <p className="text-sm text-amber-900" data-id="element-289">
                "Mi hijo de 5 años se viste solo en 10 min" - Ana, Ciudad de
                Guatemala
              </p>
            </div>
            <div className="flex items-center gap-2 bg-white px-3 py-2 rounded-full border border-amber-100" data-id="element-290">
              <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Miguel, San José" className="w-8 h-8 rounded-full object-cover" data-id="element-291" />
              <p className="text-sm text-amber-900" data-id="element-292">
                "Rutina de noche sin peleas con mi hija de 3 años" - Miguel, San
                José
              </p>
            </div>
          </div>
        </div>
        <div className="mt-8 md:mt-12 bg-amber-50 border border-amber-100 rounded-lg p-4 md:p-6" data-id="element-293">
          <h2 className="text-lg font-medium text-amber-800 mb-3" data-id="element-294">
            La mañana de María fue la gota que colmó el vaso:
          </h2>
          <p className="text-amber-900" data-id="element-295">
            Pijama en el suelo, llanto por apagar la tablet, dientes sin
            cepillar, salir tarde… otra vez. Se sentía culpable por gritar,
            agotada de repetir "¡apúrate!" y con miedo de que las noches y las
            comidas siguieran igual. Ese día decidió probar algo distinto.
          </p>
        </div>
      </div>
    </section>;
}